<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="NameCorporateName">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.NameCorporateName.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div v-if="!isRoleProvider">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('agenda.cif')}}</label>
              <el-form-item prop="TIN">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.TIN.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('persons_data.firstsurname')}}</label>
              <el-form-item prop="FirstSurname">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.FirstSurname.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('persons_data.secondsurname') }}</label>
              <el-form-item prop="SecondSurname">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.SecondSurname.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('agenda.ResidenceTypeCode')}}</label>
              <el-form-item prop="ResidenceType">
                <base-el-select class="w-full" :options="tiposResidencia" v-model="form.ResidenceType.value" clearable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('agenda.PersonTypeCode')}}</label>
              <el-form-item prop="PersonType">
                <base-el-select class="w-full" :options="tiposPersona" v-model="form.PersonType.value" clearable />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'

// import { mapGetters } from 'vuex'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel-user-provider',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'companyprovideruser',
      isOpen: this.panelOpen,
      form: {
        NameCorporateName: { label: i18n.t('app.name'), value: '' },
        TIN: { label: i18n.t('agenda.cif'), value: '' },
        FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
        SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
        ResidenceType: { label: i18n.t('agenda.ResidenceTypeCode'), value: '' },
        PersonType: { label: i18n.t('agenda.PersonTypeCode'), value: '' },
        Locations: { label: i18n.t('sedes.header'), value: '' },
        LinkedCompanies: { label: i18n.t('companies.companies_link'), value: '' },
        RegisterOfCompaniesLocation: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
      },
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  computed: {
    isRoleProvider: function () {
      return this.role === 9
    },
    tiposPersona: function () {
      return this.$store.getters['config/TIPOS_PERSONA']
    },
    tiposResidencia: function () {
      return this.$store.getters['config/TIPOS_RESIDENCIA']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.NameCorporateName.value = _temp.NameCorporateName !== undefined && _temp.NameCorporateName.value !== '' ? _temp.NameCorporateName.value : ''
        this.form.TIN.value = _temp.TIN !== undefined && _temp.TIN.value !== '' ? _temp.TIN.value : ''
        this.form.FirstSurname.value = _temp.FirstSurname !== undefined && _temp.FirstSurname.value !== '' ? _temp.FirstSurname.value : ''
        this.form.SecondSurname.value = _temp.SecondSurname !== undefined && _temp.SecondSurname.value !== '' ? _temp.SecondSurname.value : ''
        this.form.ResidenceType.value = _temp.ResidenceType !== undefined && _temp.ResidenceType.value !== '' ? _temp.ResidenceType.value : ''
        this.form.PersonType.value = _temp.PersonType !== undefined && _temp.PersonType.value !== '' ? _temp.PersonType.value : ''
        this.form.Locations.value = _temp.Locations !== undefined && _temp.Locations.value !== '' ? _temp.Locations.value : ''
        this.form.LinkedCompanies.value = _temp.LinkedCompanies !== undefined && _temp.LinkedCompanies.value !== '' ? _temp.LinkedCompanies.value : ''
        this.form.RegisterOfCompaniesLocation.value = _temp.RegisterOfCompaniesLocation !== undefined && _temp.RegisterOfCompaniesLocation.value !== '' ? _temp.RegisterOfCompaniesLocation.value : ''
      }
    },
    watchFormHandler: function () {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        NameCorporateName: { label: i18n.t('app.name'), value: '' },
        TIN: { label: i18n.t('agenda.cif'), value: '' },
        FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
        SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
        ResidenceType: { label: i18n.t('agenda.ResidenceTypeCode'), value: '' },
        PersonType: { label: i18n.t('agenda.PersonTypeCode'), value: '' },
        Locations: { label: i18n.t('sedes.header'), value: '' },
        LinkedCompanies: { label: i18n.t('companies.companies_link'), value: '' },
        RegisterOfCompaniesLocation: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
